import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormComponent } from './pages/form/form.component';
import { ListOrdersComponent } from './pages/list-orders/list-orders.component';
import { ReportComponent } from './pages/report/report.component';
import { SearchComponent } from './pages/search/search.component';
import { SharedModule } from '@app/shared/shared.module';
import { NgxCurrencyInputModule } from 'ngx-currency-input';
import { httpInterceptorProviders } from '@app/auth/interceptors';



@NgModule({
  declarations: [FormComponent, ListOrdersComponent, ReportComponent, SearchComponent],
  imports: [CommonModule, SharedModule, NgxCurrencyInputModule],
  providers: [httpInterceptorProviders, CurrencyPipe],
})
export class OrderModule { }
